"use client";
import LoadingDialog from "@/components/DialogBox/Loading";
import { createContext, useState } from "react";

const LoadingContext = createContext({
  showLoading: function (isLoading: boolean) {},
});

export function LoadingContextProvider({ ...props }) {
  const [isOpen, setIsOpen] = useState(false);

  function showLoadingHandler(isLoading: boolean) {
    setIsOpen(isLoading);
  }

  const context = {
    showLoading: showLoadingHandler,
  };

  return (
    <LoadingContext.Provider value={context}>
      <LoadingDialog isOpen={isOpen} />
      {props.children}
    </LoadingContext.Provider>
  );
}

export default LoadingContext;
